<script lang="ts">
    import FaRegCommentAlt from 'svelte-icons/fa/FaRegCommentAlt.svelte'
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let visible: boolean = true;

    function handleClick() {
        dispatch('toggleDrawer');
    }
</script>

<button class="floating-button {visible ? "visible" : ""}" on:click={handleClick}>
    <div class="icon">
        <FaRegCommentAlt />
    </div>
</button>
  
<style lang="scss">
.floating-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: var(--color-primary);
    color: white;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 24px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    z-index: 1000;

    &.visible {
        display: none;
    }
}

.floating-button .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 50%;
}

@media (max-width: 600px) {
    .floating-button {
        bottom: 3%;
        right: 5%;
    }

    .floating-button .icon {
        font-size: 20px;
    }
}
</style>
